export default __webpack_public_path__ + "static/media/glowing-star.6ea5130d.svg";